import { render } from "./ManagementPlanStep.vue?vue&type=template&id=f6be3d20&ts=true"
import script from "./ManagementPlanStep.vue?vue&type=script&lang=ts"
export * from "./ManagementPlanStep.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__